import { useState } from 'react'
import { sortTreatments } from './SortingService'
import treatmentData from './online_treatment_data.json'

export default function Treatments({
  treatments,
  showTreatments,
  showAllTreatments,
  handleBookNow,
  host,
}) {
  const AccordionItem = ({ treatment }) => {
    const [accordionOpen, setAccordionOpen] = useState(false)

    const toggleInfo = () => {
      setAccordionOpen(!accordionOpen)
    }

    return (
      <div
        className={`grid content-start gap-5 !bg-white accordion-item border border-teal-900 rounded-md h-fit lg:hover:bg-teal-900 lg:hover:!text-white transition-transform lg:transition-all duration-300 p-3 lg:p-5 ${
          accordionOpen ? 'active' : ''
        }`}
      >
        <div
          className="flex justify-between accordion-button collapsed cursor-pointer"
          data-bs-toggle="collapse"
          data-bs-target={`#concern_${treatment.serviceId}`}
          aria-expanded="false"
          onClick={(e) => toggleInfo(e)}
        >
          <div className="grid content-start">
            <h4 className="text-base lg:text-lg">
              {treatment.title ? treatment.title : treatment.displayName}
            </h4>
            <p
              className={`accordion-price font-bold transition-all !duration-0 ${
                accordionOpen ? 'occult' : 'active'
              }`}
            >
              {treatment.price}
            </p>
          </div>
          <svg
            className={`transition-all duration-150 ${accordionOpen ? 'rotate-180': ''}`}
            width="14"
            viewBox="0 0 14 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M.266.229a.991.991 0 0 1 1.186-.06l.084.065L7 5.088 12.463.234a.991.991 0 0 1 1.186-.07l.085.065a.722.722 0 0 1 .08 1.043l-.074.074-6.1 5.42a.94.94 0 0 1-.482.222l-.102.01L6.972 7 6.9 6.996a.953.953 0 0 1-.454-.163l-.085-.067L.26 1.346A.725.725 0 0 1 .266.23z"
              fill="currentColor"
            />
          </svg>
        </div>
        <div
          className={`accordion-collapse transition-all duration-300 ${
            accordionOpen ? 'open' : 'collapsed'
          }`}
          data-bs-parent="#concernList"
          id={`concern_${treatment.serviceId}`}
        >
          <div className="accordion-body grid content-start gap-4">
            <div className="grid content-start lg:flex lg:justify-between lg:gap-3">
              <p>
                {treatment.description
                  ? treatment.description
                  : treatment.shortDesc}{' '}
                {treatment.serviceId ===
                  '50c19798-09d9-4f12-ba26-b14c00f71b2a' && (
                  <a
                    href="/weight-loss"
                    className="link-light link-offset-2 link-underline-opacity-100 link-underline-opacity-50-hover"
                  >
                    Learn more
                  </a>
                )}
              </p>
              <div className="hidden content-start lg:grid">
                <p className="font-bold">Duration</p>
                <div className="flex items-center justify-center mt-1 text-xs">
                  {host && (
                    <img
                      className="me-1"
                      src={`${host}/wp-content/plugins/services-selector/services-selector-module/assets/img/icon-clock--white.png`}
                      width="15"
                      height="15"
                      alt="clock"
                    />
                  )}{' '}
                  {treatment.duration}
                </div>
              </div>
            </div>

            <div className="flex justify-between">
              <p className="font-bold">{treatment.price}</p>
              <div className="grid content-start lg:hidden">
                <p className="font-bold">Duration</p>
                <div className="flex items-center justify-center mt-1 text-xs">
                  {host && (
                    <img
                      className="me-1"
                      src={`${host}/wp-content/plugins/services-selector/services-selector-module/assets/img/icon-clock--white.png`}
                      width="15"
                      height="15"
                      alt="clock"
                    />
                  )}{' '}
                  {treatment.duration}
                </div>
              </div>
            </div>
            {treatment.id !== 'bba7cb79-02ce-48eb-9383-b12a002161c1' && (
              <div className="flex flex-wrap gap-2 mt-2">
                {treatment.concerns.map((concern, index) => (
                  <div
                    key={`treatment_${treatment.slug}_${concern}`}
                    className={`border border-white text-xs rounded-full px-2 py-1`}
                  >
                    {concern.toLowerCase()}
                  </div>
                ))}
              </div>
            )}
            <div className="button-group text-center">
              <button
                type="button"
                className="bg-transparent text-white border border-white uppercase font-bold text-sm rounded-full px-12 py-3 lg:hover:bg-white lg:hover:text-teal-900 lg:hover:border-teal-900 transition-all duration-300"
                onClick={() => handleBookNow(treatment)}
              >
                Book Appointment
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
  // Determine the list of treatments to display
  const displayedTreatments = showAllTreatments
    ? treatmentData // Render all treatments from treatmentData
    : treatments // Render only the filtered treatments passed as a prop

  return (
    <div
      className={`services-area__treatments overflow-auto pt-5 pb-20 ${
        showTreatments ? 'show' : 'hide'
      }`}
    >
      <div className="accordion grid content-start gap-2" id="treatmentList">
        {!displayedTreatments.length && (
          <div>
            <p>
              We don't seem to have treatments for that combination of concerns.
              Try going back and changing your selections.
            </p>
            <p>
              If you're not seeing the treatments you'd like, or having trouble
              with this form, please call us at (203) 973-7829
            </p>
          </div>
        )}
        {displayedTreatments.sort(sortTreatments).map((treatment) => (
          <AccordionItem
            treatment={treatment}
            key={`treatment_${treatment.serviceId}`}
          />
        ))}
      </div>
    </div>
  )
}
